module.exports = __webpack_public_path__ + "img/31.bcae5713.gif";